import { z } from 'zod';

import { fullNameSchema, transformFullNameSchema } from 'components/shared/types/FullNameSchema';

export const managerMeetingSchema = z
  .object({
    phone: z.string(),
    email: z.string().nullable(),
    ...fullNameSchema.shape,
  })
  .transform((raw) => ({
    phone: raw.phone,
    email: raw.email,
    ...transformFullNameSchema.parse(raw),
  }));

export const responsibleMeetingSchema = z
  .object({
    ...fullNameSchema.shape,
    phone: z.string(),
    email: z.string(),
    position: z.string().optional(),
  })
  .transform((raw) => ({
    ...transformFullNameSchema.parse(raw),
    phone: raw.phone,
    email: raw.email,
    position: raw.position,
  }));

export type ManagerMeeting = z.infer<typeof managerMeetingSchema>;
export type ResponsibleMeeting = z.infer<typeof responsibleMeetingSchema>;
